// import hooks
import { useGetAdminFunctionGroups } from 'queries';
import { isNil } from 'ramda';

// import types
import { AdminFunction, FunctionFlag } from '../AdminFunctions.types';

// import components
import { ValueOptions } from '@mui/x-data-grid-pro';

const useGetFunctionGroupFilterOptions = (): ValueOptions[] => {
  const { data: functionGroups } = useGetAdminFunctionGroups(
    FunctionFlag.FUNCTION_GROUP
  );

  if (isNil(functionGroups)) {
    return [];
  }

  return functionGroups.map((functionGroup: AdminFunction) => ({
    value: functionGroup.description,
    label: functionGroup.description
  }));
};

export default useGetFunctionGroupFilterOptions;
